module.exports = __webpack_public_path__ + "static/img/23_guangzhaoqiangdu.1815c65d.png";